import classNames from 'classnames';

const BLUR_CLASS = 'backdrop-blur-[16px]';

interface Props {
  className?: string;
  height?: string | number;
  direction?: 'up' | 'down';
  gradientColor?: string;
}

export const ProgressiveBlur = ({ className, height, direction = 'up', gradientColor }: Props) => {
  const maskDirection = direction === 'up' ? 'to top' : 'to bottom';
  const gradientDirection = direction === 'up' ? '180deg' : '0deg';
  const heightStyle =
    height !== undefined ? { height: typeof height === 'number' ? `${height}px` : height } : undefined;

  return (
    <>
      <div
        className={classNames('pointer-events-none', BLUR_CLASS, className)}
        style={{
          ...heightStyle,
          maskImage: `linear-gradient(${maskDirection}, black 0%, transparent 100%)`,
          WebkitMaskImage: `linear-gradient(${maskDirection}, black 0%, transparent 100%)`,
        }}
      />
      {gradientColor && (
        <div
          className={classNames('pointer-events-none', className)}
          style={{
            ...heightStyle,
            opacity: 0.7,
            backgroundImage: `linear-gradient(${gradientDirection}, transparent 0%, ${gradientColor} 100%)`,
            maskImage: `linear-gradient(${maskDirection}, black 0%, transparent 100%)`,
            WebkitMaskImage: `linear-gradient(${maskDirection}, black 0%, transparent 100%)`,
          }}
        />
      )}
    </>
  );
};

export default ProgressiveBlur;
